module.exports = __webpack_public_path__ + "static/apuntes_proba-1e40c922c40e93a80cf471a50d282f9c.pdf";